import { Injectable } from '@angular/core';
import { BaseErrorMappingService } from '../base-error-mapping.service';
import type { ErrorRule } from '../../../models/error-mapping.model';

@Injectable({
  providedIn: 'root'
})
export class TelemedicineErrorMappingService extends BaseErrorMappingService {
  protected rules: ErrorRule[] = [
    {
      pattern: /\/TelemedicineUsers\/Person/,
      messages: {
        400: 'errors.getTelemedicineUserFailed',
        404: 'errors.getTelemedicineUserFailed',
        500: 'errors.getTelemedicineUserFailed',
        success: {
          default: 'telemedicineSetup.errors.getTelemedicineUserFailed'
        }
      },
      options: {
        showInInterceptor: true,
        duration: 5000
      }
    },
    {
      pattern: /\/TelemedicineUsers\/Update/,
      messages: {
        400: 'errors.updateTelemedicineUserFailed',
        404: 'errors.updateTelemedicineUserFailed',
        500: 'errors.updateTelemedicineUserFailed',
        success: {
          default: 'errors.updateTelemedicineUserFailed'
        }
      },
      options: {
        showInInterceptor: true,
        duration: 5000
      }
    },
    {
      pattern: /\/TelemedicineUsers\/Create/,
      messages: {
        400: 'errors.createTelemedicineUserFailed',
        404: 'errors.createTelemedicineUserFailed',
        500: 'errors.createTelemedicineUserFailed',
        success: {
          default: 'errors.createTelemedicineUserFailed'
        }
      },
      options: {
        showInInterceptor: true,
        duration: 5000
      }
    },
    {
      pattern: /\/LightCensusLines\/Telemedicine/,
      messages: {
        400: 'errors.getTelemedicineCensusLinesFailed',
        404: 'errors.getTelemedicineCensusLinesFailed',
        500: 'errors.getTelemedicineCensusLinesFailed',
        success: {
          default: 'errors.getTelemedicineCensusLinesFailed'
        }
      },
      options: {
        showInInterceptor: true,
        duration: 5000
      }
    },
    {
      pattern: /\/CustomerActivity\/Telemed/,
      messages: {
        400: 'errors.error400OnTelemedicineLog',
        404: 'errors.error400OnTelemedicineLog',
        500: 'errors.error400OnTelemedicineLog',
        success: {
          default: 'errors.error400OnTelemedicineLog'
        }
      },
      options: {
        showInInterceptor: true,
        duration: 5000
      }
    }
  ];
}
